/**
 * @fileoverview Contrato del cliente de contraseña de portal-api-zonasegura.
 * Solo cubre definir la contraseña tras validar el OTP; el cambio con sesión sigue en ZS Backend.
 * @module integrations/password.integration
 */

import { createPasswordIntegration } from './impl/password.integration.impl'

/**
 * Contrato del cliente de contraseña. Rechaza con un IntegrationError.
 * @typedef {Object} PasswordIntegration
 * @property {function(string, string): Promise<import('./models/auth.models').PasswordSetupResponse>} setup
 *   POST auth/password/setup con el passwordSetupToken. Con 98/97 el token no se consume y se puede reintentar.
 */

/** @type {PasswordIntegration} */
const passwordIntegration = createPasswordIntegration()

export default passwordIntegration



// WEBPACK FOOTER //
// ./src/integrations/password.integration.js